/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Assistant_Agent_Team_Credits_LeftInputs */



/**
* | output |
* | --- |
* | "{count} team credits left" |
*
* @param {Assistant_Agent_Team_Credits_LeftInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_agent_team_credits_left = /** @type {((inputs: Assistant_Agent_Team_Credits_LeftInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_Agent_Team_Credits_LeftInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Crédits de l'équipe ${i?.count} restants`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Verbleibende Team-Credits von ${i?.count}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`crediti rimanenti del team ${i?.count}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Осталось указание авторов команды ${i?.count}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Créditos restantes del equipo ${i?.count}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`${i?.count} 团队剩余积分`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.count} チームクレジット残り`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.count} टीम क्रेडिट्स बचे`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Créditos da equipe ${i?.count} restantes`)
	return /** @type {LocalizedString} */ (`${i?.count} team credits left`)
});